import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  saveCarnival,
  getLeadInfraId,
  getprojectOnboardingListForFinance
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import businessListingAll from './businessListingAll';
import {
    getPreSaleListing,
    getStatusList,
    getDealStatusList,
    UpdateLeadStatus,
    getListFilterData,
    fetchZones,
} from "services/redux/sales/preSaleListing/action";
import {
  pocSiteType,
  pocSubSiteType,
  pocType,
} from "services/redux/sales/corporate/pocDetails/action";

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  pocSiteTypeData: state.pocTypesReducer.pocSiteTypeData,
  pocSubSiteTypeData: state.pocTypesReducer.pocSubSiteTypeData,
  leadInfraId: state.ConductCampReducer.leadInfraId,
  projectOnboradingListing: state.ConductCampReducer.projectOnboradingListing,
  perSalesList: state.preSalesListReducer.perSalesList,
  statusList: state.preSalesListReducer.statusList,
  dealStatusList: state.preSalesListReducer.dealStatusList,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getLeadInfraId,
      saveCarnival,
      getprojectOnboardingListForFinance,
      getPreSaleListing,
      getStatusList,
      getDealStatusList,
      UpdateLeadStatus,
      getListFilterData,
      fetchZones,
      pocSiteType,
      pocSubSiteType,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(businessListingAll);
